import { apiService } from '../Config/api.service';

/**
 * Résolution de l'identité du portail (Yros/Kavero#314, unit 1).
 *
 * L'ordre EST la garde. `/proxy/api/user` retombe sur le rôle interne `user`
 * pour n'importe quel compte authentifié, y compris un compte Portail :
 * l'interroger en premier typerait l'employé comme un interne et lui ouvrirait
 * tout le portail RH. C2 (`/rh/contexte`) est donc consulté d'abord, avec le
 * même ordre et pour la même raison que le proxy en `007`.
 *
 * C2 ne conclut que sur la chaîne exacte `employee`. `false`, un rôle hors des
 * rôles connus, un corps inattendu, un 404 (module RH absent) ou une panne
 * réseau sont autant de doutes, et un doute se replie sur `/user` :
 * **un échec de C2 ne type jamais quelqu'un `employee`**.
 *
 * Le rejet de `/user`, lui, remonte à l'appelant : une panne reste une panne.
 * Le `catch` d'`App.js` refuse alors l'accès par défaut — on ne fabrique pas
 * ici une identité de secours qui masquerait l'incident.
 *
 * L'identité porte aussi l'offre souscrite (`offre_rh`, YRH-FOUND-014), lue
 * dans la même réponse C2. Elle ne vaut vrai que sur un `true` littéral : un
 * doute masque le RH, jamais l'inverse.
 *
 * Le droit « Correction des pointages » (`corriger_pointages`, YRH-CORE-013)
 * suit la même règle, en plus strict : la clé n'est posée que quand C2 dit
 * `true`, jamais à faux, et seul un compte interne la porte.
 */
export async function resoudreIdentite() {
    let roleContexte;
    let offreRh = false;
    let corrigerPointages = false;
    let manager = false;
    let validerHeuresSup = false;
    try {
        const reponse = await apiService.getElement('/rh/contexte');
        roleContexte = reponse?.data?.role;
        offreRh = reponse?.data?.capacites?.offre_rh === true;
        corrigerPointages = reponse?.data?.capacites?.corriger_pointages === true;
        // Yros/Kavero#361 : le compte Portail a une équipe. La clé n'existe
        // dans l'identité que vraie, comme `corriger_pointages`.
        manager = reponse?.data?.capacites?.manager === true;
        // Yros/Kavero#491 : le validateur des heures sup du pointage, RH ou non.
        validerHeuresSup = reponse?.data?.capacites?.valider_heures_sup === true;
    } catch (erreur) {
        // C2 injoignable : on ne conclut rien, on se replie. Voir ci-dessus.
        roleContexte = undefined;
    }

    if (roleContexte === 'employee') {
        return {
            role: 'employee', offre_rh: offreRh,
            ...(manager ? { manager: true } : {}),
            ...(validerHeuresSup ? { valider_heures_sup: true } : {}),
        };
    }

    const reponse = await apiService.getElement('/user');
    const utilisateur = reponse?.data?.user;
    return utilisateur && utilisateur.id
        ? {
            ...utilisateur, offre_rh: offreRh,
            ...(corrigerPointages ? { corriger_pointages: true } : {}),
            ...(validerHeuresSup ? { valider_heures_sup: true } : {}),
        }
        : null;
}
